import React, {useMemo} from 'react';
import {useTranslation} from 'react-i18next';

import {Card, FileArea, FileOwner, FilesManager} from 'components';
import {TRANSLATION_KEYS} from 'locale';
import {userAuthUtils} from 'utils';

const T_KEYS = TRANSLATION_KEYS.USER.ACCOUNT.SESSION.IN_SESSION.VIRTUAL_BACKGROUND_MANAGEMENT;

export const VirtualBackgroundManagement: React.FC = () => {
    const {t} = useTranslation();

    const localUser = useMemo(() => userAuthUtils.getLocalUser(), []);

    return (
        <div className='tw-relative tw-my-10'>
            <Card className='tw-px-10 -sm:tw-px-5'>
                <div className='tw-mb-8'>
                    <span className='tw-ts-h5-bold'>{t(T_KEYS.TITLE)}</span>
                </div>

                <FilesManager
                    ownerType={FileOwner.Account}
                    ownerId={localUser.accountId}
                    area={FileArea.SessionVirtualBackground}
                    imageOnly
                    imageSize='lg'
                    selectable={false}
                />
            </Card>
        </div>
    );

};